var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cartDropdownEmpty"},[_c('div',{staticClass:"cartDropdownEmpty__title"},[_vm._v("\n    "+_vm._s(_vm.$t('myCart'))+"\n  ")]),_vm._v(" "),_c('cart-empty-info',{staticClass:"cartDropdownEmpty__inner"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }